export enum IntegrationPlatformType {
  SHOPIFY = 'SHOPIFY',
  PIPEDRIVE = 'PIPEDRIVE',
  LIVECHAT = 'LIVECHAT',
  MAGENTO = 'MAGENTO',
  SHOPER = 'SHOPER',
  SHOPER_CONNECT = 'SHOPER_CONNECT',
  HUBSPOT = 'HUBSPOT',
  ZENDESK = 'ZENDESK',
  ZAPIER = 'ZAPIER',
  TWO_WAY = 'TWO_WAY',
  INTEGROMAT = 'INTEGROMAT',
  CLIENTIFY = 'CLIENTIFY',
}

export interface IntegrationModel {
  platformType: IntegrationPlatformType;
  integrated: boolean;
  availableToInstall: boolean;
}

export interface IntegratedPlatform {
  id: number;
  platformType: IntegrationPlatformType;
  accountName: string;
  resyncEnabled: boolean;
}

export interface IntegrationPlatformImport {
  id: number;
  status: 'STARTED' | 'FINISHED' | 'FAILED';
  operation: 'IMPORT' | 'RESYNC' | 'AUTO_RESYNC';
  startDate: Date;
  finishDate: Date;
}
